import React from 'react';

import { LicenseInfo } from "@mui/x-data-grid-pro";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
    faAddressBook as fasFaAddressBook,
    faBoxes as fasFaBoxes,
    faBroom as fasFaBroom,
    faCartArrowDown as fasFaCartArrowDown,
    faCartPlus as fasFaCartPlus,
    faFile as fasFaFile,
    faFileExport as fasFaFileExport,
    faFolder as fasFaFolder,
    faForklift as fasFaForklift,
    faShieldHalved as fasFaShieldHalved,
    faHome as fasFaHome,
    faKey as fasFaKey,
    faPersonCarry as fasFaPersonCarry,
    faPlus as fasFaPlus,
    faRepeat as fasFaRepeat,
    faSave as fasFaSave,
    faScannerImage as fasFaScannerImage,
    faSearch as fasFaSearch,
    faShoppingCart as fasFaShoppingCart,
    faSignOut as fasFaSignOut,
    faTrash as fasFaTrash,
    faWarehouseAlt as fasFaWarehouseAlt,
    faXmark as fasFaXmark,
    faArrowRight as fasFaArrowRight,
    faAnalytics as fasFaAnalytics,
    faUpRightFromSquare as fasFaUpRightFromSquare,
} from "@fortawesome/pro-solid-svg-icons";

import {
    faCheckCircle as farFaCheckCircle,
    faEdit as farFaEdit,
    faEye as farFaEye,
    faFileImage as farFaFileImage,
    faLock as farFaLock,
    faSearch as farFaSearch,
    faShoppingCart as farFaShoppingCart,
    faTimes as farFaTimes,
    faTimesCircle as farFaTimesCircle,
    faFileCsv as fasFaFileCsv,
    faPrint as fasFaPrint,
    faChevronRight as farFaChevronRight,
    faChevronLeft as farFaChevronLeft,
    faHome as farFaHome,
    faPlus as farFaPlus,
    faUpRightFromSquare as farFaUpRightFromSquare,
} from "@fortawesome/pro-regular-svg-icons";

import './App.css';
import { createTheme, CssBaseline } from "@mui/material";
import Main from "./Main";
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import { AlertProvider } from './context/AlertContext/AlertContext';
import { theme } from './themes/theme'; // Import the theme

library.add(
    fasFaPrint,
    fasFaFileCsv,
    fasFaAddressBook,
    fasFaBoxes,
    fasFaBroom,
    fasFaCartArrowDown,
    fasFaCartPlus,
    fasFaFile,
    fasFaFileExport,
    fasFaFolder,
    fasFaForklift,
    fasFaShieldHalved,
    fasFaHome,
    fasFaKey,
    fasFaPersonCarry,
    fasFaPlus,
    fasFaRepeat,
    fasFaSave,
    fasFaScannerImage,
    fasFaSearch,
    fasFaShoppingCart,
    fasFaSignOut,
    fasFaTrash,
    fasFaWarehouseAlt,
    fasFaXmark,
    fasFaArrowRight,
    fasFaAnalytics,
    fasFaUpRightFromSquare,
    farFaHome,
    farFaPlus,
    farFaUpRightFromSquare,
    farFaCheckCircle,
    farFaEdit,
    farFaEye,
    farFaFileImage,
    farFaLock,
    farFaSearch,
    farFaShoppingCart,
    farFaTimes,
    farFaTimesCircle,
    farFaChevronRight,
    farFaChevronLeft
)

function App(): JSX.Element {
    LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_KEY ?? "");

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <AlertProvider>
                    <Main/>
                </AlertProvider>
            </ThemeProvider>
        </StyledEngineProvider>
    );
}

export default App;
